import { GridProps } from '@mui/material';
import { FormFieldProps, FormTextField } from '../index';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type FormChildAllowanceFieldProps = FormFieldProps &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'> & { max?: number };

export const FormChildAllowanceField: FC<FormChildAllowanceFieldProps> = (props) => {
  const { t } = useTranslation();

  return (
    <FormTextField
      {...props}
      type="number"
      label={t('employee:KINDERFREIBETRAG')}
      placeholder={t('employee:KINDERFREIBETRAG')}
      inputProps={{
        min: 0,
        max: props.max,
        step: 0.5
      }}
    />
  );
};
